export default "__VITE_ASSET__umgvXn1m__"